import type { ReactNode } from 'react';
import { Modal } from '../Modal/Modal';
import { useTranslation } from '../../../i18n/useTranslation';
import './ConfirmDialog.css';

interface ConfirmDialogProps {
  title: string;
  /** What the action actually costs. Deleting a student takes their lessons. */
  body: string;
  confirmLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /** For the cases that need one more answer before confirming, such as a
   *  cancellation reason. */
  children?: ReactNode;
}

export function ConfirmDialog({
  title,
  body,
  confirmLabel,
  destructive = false,
  onConfirm,
  onCancel,
  children
}: ConfirmDialogProps) {
  const { tr } = useTranslation();
  return (
    <Modal
      title={title}
      onClose={onCancel}
      footer={
        <>
          <button type="button" className="ghost-button" onClick={onCancel}>
            {tr('cancel')}
          </button>
          <button
            type="button"
            className={destructive ? 'primary-button is-destructive' : 'primary-button'}
            onClick={onConfirm}
          >
            {confirmLabel ?? tr('confirm')}
          </button>
        </>
      }
    >
      <p className="confirm-body">{body}</p>
      {children}
    </Modal>
  );
}
